import React from "react";
import ComponentTitle from "../Home/ComponentTitle";
import useScrollToTop from "../../hooks/useScrollToTop";

const AboutMonAppliClubOmnisports = () => {
  useScrollToTop();

  const handleDemoClick = () => {
    window.open("https://www.union-sportive-bouscataise.com/", "_blank");
  };

  return (
    <section id="about" className="py-16 bg-gray-100 dark:bg-neutral-900 text-gray-800 dark:text-gray-200">
      <div className="container mx-auto px-4">
        {/* Titre principal */}
        <div className="mx-auto max-w-screen-md text-center mb-12">
          <ComponentTitle title="Quelques" highlight=" Fonctionnalités" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Bloc Photo */}
          <div className="bg-slate-100 dark:bg-neutral-800 p-6 rounded-lg">
            <img
              src="/images/appli_telomni_01.webp"
              alt="illustration de l'application MonAppliClub Omnisports"
              className="rounded-lg mx-auto w-full object-cover"
            />
          </div>

          {/* Bloc Adhérents */}
          <div className="bg-slate-200 dark:bg-neutral-800 p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-4 bg-blue-200 dark:bg-blue-500 p-2 rounded-md shadow-md">Visiteurs</h3>
            <ul className="list-none">
              <li className="mb-4">✔️ Affichage des informations concernant l'association omnisports'</li>
              <li className="mb-4">✔️ Affichage des sections sportives</li>
              <li className="mb-4">✔️ Les dernières actualités</li>
              <li className="mb-4">✔️ Les prochains événements</li>
              <li className="mb-4">✔️ Les albums photos</li>
              <li className="mb-4">✔️ Les palmarès</li>
              <li className="mb-4">✔️ Les sites sportifs de la commune</li>
              <li className="mb-4">✔️ Les responsables sports</li>
              <li className="mb-4">✔️ Formulaire de contact</li>
            </ul>
          </div>

          {/* Bloc Enseignants */}
          <div className="bg-slate-200 dark:bg-neutral-800 p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-4 bg-red-200 dark:bg-red-500 p-2 rounded-md shadow-md">Espace Administrateur</h3>
            <ul className="list-none">
              <li className="mb-4">✔️ Tableau de bord</li>
              <li className="mb-4">✔️ Réception des messages du formulaire de contact</li>
              <li className="mb-4">✔️ Chaque Section gère les données présentes sur le mini-site de la section</li>
              <li className="mb-4">✔️ Gestion des articles, albums, événements, palmarès, groupes & tarifs</li>
              <li className="mb-4">✔️ L'administrateur gère les responsables des sections, les partenaires, les sections ...</li>
              <li className="mb-4">✔️ Compteur de visite.</li>
            </ul>
          </div>

          {/* Bloc Photo */}
          <div className="bg-slate-100 dark:bg-neutral-800 p-6 rounded-lg">
            <img
              src="/images/appli_teomni_02.webp"
              alt="illustration de l'application MonAppliClub Omnisports"
              className="rounded-lg mx-auto w-full object-cover"
            />
          </div>
        </div>

        {/* Bouton de démo */}
        <div className="mt-8 text-center mx-auto">
          <button
            onClick={handleDemoClick}
            className="px-8 py-3 bg-gradient-to-r from-yellow-400 to-orange-600 text-white rounded-full transition relative group w-96"
          >
            <span className="group-hover:opacity-0 transition-opacity duration-300">
              Voir Site en Ligne
            </span>
            <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 font-passionOne text-3xl font-light">
              Union Sportive Bouscataise
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutMonAppliClubOmnisports;
